import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IdentityAuthService } from '../services/identity-auth.service';

@Component({
  selector: 'app-signout-oidc',
  templateUrl: './signout-oidc.component.html',
  styleUrls: ['./signout-oidc.component.scss']
})
export class SignoutOidcComponent implements OnInit {


  constructor(
    private identityAuth: IdentityAuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.router.navigate(["session/signin"]);
  }

  login(): void {
    this.router.navigate(["session/signin"]);
  }

}
